import React, { Component } from 'react';
import Modal from 'react-modal';
import styles from '../Report/Report.less';
import i18next from 'i18next';
import deliveryStyles from './Delivery.less';
import { DropdownButton, MenuItem } from "react-bootstrap";
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import removeRowIcon from '../../../static/images/remove-row-icon.png';
import addrowIcon from '../../../static/images/add-row-icon.png';
import clockIcon from '../../../static/images/clock-icon.png';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
import moment from 'moment';
import { connect } from 'react-redux';
import * as commonActions from '../../actions/commonActions';
import ReactDOM from 'react-dom';
import { getFormattedRate, getMinMaxFractionDigits, getPureNumber, setDirection } from './../../utils/utils';


function parseToNumber(value) {
  if (typeof value === 'number') {
    return value; // Already a number
  }

  if (typeof value === 'string') {
    // Remove commas and extra spaces
    const cleaned = value.replace(/,/g, '').trim();
    const num = Number(cleaned);
    return isNaN(num) ? null : num;
  }

  return null; // Not a number or string
}
@connect(state => ({
    selectedLang: state.dashboardRoot.commonReducer.selectedLang,
    language: state.dashboardRoot.commonReducer.language,
    locationDetails: state.dashboardRoot.commonReducer.locationDetails,
    premiumDetails: state.dashboardRoot.commonReducer.premiumDetails,
    unitDetails: state.dashboardRoot.commonReducer.unitDetails,
    userDetail: state.auth.userDetail,
    ACD: state.auth.ACD,
    DFA: state.auth.DFA,
    currencyData: state.dashboardRoot.instrumentListReducer.currencyData,
}), {
    ...commonActions
})

export default class PlaceRequest extends Component {
    constructor(props) {
        super(props);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.handleChangeDate = this.handleChangeDate.bind(this);
        const locationDetails = [];
        const premiumDetails =  [];
        const initialRows = [],
        openPositions = props.openPositionsData || [];

        const mandatoryTitle = (label) => (
            <>
                {i18next.t(label)} <span className={deliveryStyles.mandatory}> *</span>
            </>
        );

        this.state = {
            locationDetails,
            selectedCmdty: {},
            selectedLocation: {},
            timeOptions: [],
            columns: [
                { name: 'stock', title: mandatoryTitle('stock') },
                { name: 'qty', title: mandatoryTitle('Pcs') },
                { name: 'qtyOZ', title: i18next.t('qty') + ' ' + this.props.userDetail.CompanyBaseName, type: 'number'},
                { name: 'premRate', title: i18next.t('premRate') },
                { name: 'premAmt', title: i18next.t('premAmt') + ' (USD)', type: 'number' },
            ],
            rows: initialRows,
            newRow: { stock: '', qty: '', qtyOZ: '', premRate: '', premAmt: '' },
            startDate: null,
            collectionTime: '',
            errorMsg: '',
            premiumDetails,
            selectedCurrency: (this.props.currencyData || []).find(
                item => item.S === this.props.DFA?.DC
            ) ?? null,           
            amtInSelectedCurrency: '',
        };
    }

    componentDidMount() {
        //Call getPremium API
        this.props.getPremiumDetails()
        this.props.getLocations()

        this.setState({
            openPositions: this.props.openPositionsData || [],
        })
    }


    componentWillReceiveProps(nextProps) {
        if(nextProps.locationDetails !== this.props.locationDetails) {
            const locationDetails = nextProps.locationDetails
            // const timeOptions = this.generateTimeOptions(locationDetails[0]?.workingHourStart, locationDetails[0]?.workingHourEnd);
            const timeOptions = []

            //CHECK
            this.setState({
                locationDetails : locationDetails,
                selectedLocation: " ",
                timeOptions: timeOptions
             });
        }

        const premiumChanged = nextProps.premiumDetails !== this.props.premiumDetails;
        const openPositionsChanged = nextProps.openPositionsData !== this.props.openPositionsData;

        const { premiumDetails, openPositionsData } = nextProps;

        if (premiumChanged || openPositionsChanged) {
            const bothAvailable = Array.isArray(premiumDetails) && premiumDetails.length > 0 &&
                Array.isArray(openPositionsData) && openPositionsData.length > 0;

            if ((premiumChanged && bothAvailable) || (premiumChanged && this.props.userDetail.enableShortForPD)) {
                const filteredPremiums = premiumDetails.filter(prem => {
                    const match = openPositionsData.find(pos => {
                        const matched = pos.cmdty === prem.DESC;
                        return matched && parseToNumber(pos.position) > 0;
                    });

                    return match;
                });

                this.setState({
                    premiumDetails: this.props.userDetail.enableShortForPD ? premiumDetails : filteredPremiums,
                    selectedCmdty: this.props.userDetail.enableShortForPD ? premiumDetails[0] : filteredPremiums[0] || null,
                    openPositions: openPositionsData,
                });
            } else if (openPositionsChanged) {
                this.setState({
                    openPositions: openPositionsData,
                });
            }
        }

        if (nextProps.DFA !== this.props.DFA) {
            const newSelectedCurrency = (nextProps.currencyData || []).find(
                item => item.S === nextProps.DFA?.DC
            ) ?? null;
            this.setState({ selectedCurrency: newSelectedCurrency });
        }
    }

    handleChangeDate = (date) => {
        try {
            this.setState({ startDate: date });
        } catch (e) {
            this.props.logFileCreation({ error: e.message, originFunction: 'handleChangeDate', component: "LimitOrderComponent" });
        }
    }

    handleCloseClick = () => {
        this.props.onClose();
    };

    handleSubmitClick = () => {
    let { rows, collectionTime, startDate, selectedCmdty, selectedLocation , newRow} = this.state;
    let hasEmpty = false;
    let errorMsg = '';

    // Include newRow if it has valid stock and qty > 0
    if (newRow.stock) {
        if (!newRow.qty || newRow.qty === '0') {
            hasEmpty = true;
            errorMsg = "Please enter Pcs greater than zero.";
        } else {
            // Only add if valid
            rows = [...rows, newRow];
            }
        }

    // Step 1: Basic validation
    if (!hasEmpty && (!startDate || !rows.length || !collectionTime)) {
        hasEmpty = true;
        errorMsg = "Please fill all required fields before submitting."
    }

    if (!hasEmpty && rows.some(row => row.qty == '0')) {
        hasEmpty = true;
        errorMsg = "Please enter Pcs greater than zero.";
    }

    if (hasEmpty) {
        this.setState({ errorMsg });
        return;
    }
    this.setState({ errorMsg: '' });
    this.props.onClose();

    // Step 2: Format collection time → ensure hour has two digits
    let formattedCollectionTime = collectionTime;
    if (typeof formattedCollectionTime === 'string' && formattedCollectionTime.trim() !== "") {
        const [timePart, period] = collectionTime.trim().split(' ');
        if (timePart && period) {
            const [hour, minute] = timePart.split(':');
            const paddedHour = hour.padStart(2, '0');
            formattedCollectionTime = `${paddedHour}:${minute} ${period}`;
        }
    }

    // Step 3: Extract rounding & formatting rules from selectedCmdty
    const qtyRound = selectedCmdty?.STOCK_QTY_ROUND ?? 3;
    const premRound = selectedCmdty?.STOCK_RATE_ROUND ?? 2;
    const qtyFormat = selectedCmdty?.STOCK_QTY_FORMAT ?? '#,##0.000';
    const premFormat = selectedCmdty?.STOCK_RATE_FORMAT ?? '#,##0.00';

    // Step 4: Helper → parse format string (e.g. "#,##0.000")
    const parsePattern = (pattern) => {
        const [intPart, fracPart = ''] = pattern.split('.');
        const grouping = intPart.indexOf(',') !== -1;
        const fractionDigits = fracPart.length;
        return { grouping, fractionDigits };
    };

    // Step 5: Helper → round numeric value
    const roundValue = (value, round) => {
        const num = Number(value || 0);
        if (Number.isNaN(num)) return 0;
        return Number(num.toFixed(round));
    };

    // Step 6: Helper → format number based on pattern
    const applyPattern = (value, pattern) => {
        const { grouping, fractionDigits } = parsePattern(pattern);
        const num = Number(value);
        if (Number.isNaN(num)) return '';
        return new Intl.NumberFormat('en-US', {
            useGrouping: grouping,
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits
        }).format(num);
    };

    // Step 7: Combined helper → round first, then format
    const formatNumber = (value, round, pattern) => {
        const rounded = roundValue(value, round); // Step A: round
        return applyPattern(rounded, pattern);    // Step B: format
    };

    // Step 8: Calculate totals with rounding + formatting
    const totalQtyOZ = formatNumber(
        rows.reduce((sum, r) => sum + getPureNumber(r.qtyOZ || 0), 0),
        qtyRound,
        qtyFormat
    );
    const totalPrem = formatNumber(
        rows.reduce((sum, r) => sum + getPureNumber(r.premAmt || 0), 0),
        premRound,
        premFormat
    );

    // Step 9: Transform row data with rounding + formatting

    const rateMinMax = getMinMaxFractionDigits(this.state.selectedCmdty?.STOCK_RATE_FORMAT || '#,##0.000');
    const rateRoundOff = this.state.selectedCmdty?.STOCK_RATE_ROUND ?? 2;

    const transformedData = rows.map(item => ({
        SC: item.stock,
        PQ: getPureNumber(item.qty),
        GQ: getPureNumber(item.qtyOZ),
        PREM: getPureNumber(item.premRate.split('/')[0] || 0),
        PAMT: getPureNumber(item.premAmt),
        PUNIT: item.premRate.split('/')[1] || '',
        FC_PAMT: this.state.selectedCurrency ? getFormattedRate(getPureNumber(item.premAmt) * this.state.selectedCurrency.R, rateMinMax.maximumFractionDigits, rateMinMax.maximumFractionDigits, true, rateRoundOff) : '',
    }));

    // Step 10: Build payload
  
    const firstValue = this.props.ACD.values().next().value;
    const AC = firstValue.C;
    const AD = firstValue.D;

    const AccDet = JSON.parse(localStorage.getItem('DFA'));

    const payload = {
        CMDTY: selectedCmdty.DESC,
        CMDTY_DESC: selectedCmdty.STK_TYPE,
        LOC: selectedLocation.locationCode || '',
        DLD: startDate.format('DD-MMM-YYYY'),
        DLT: formattedCollectionTime || "",
        DATA: transformedData,
        RMK: document.getElementById('placeReqComment').value,
        TOTAL_GQ: getPureNumber(totalQtyOZ),
        TOTAL_PAMT: getPureNumber(totalPrem),
        TZ: selectedLocation.timezone ? `${selectedLocation.timezone}` : '',
        AC: AccDet.C,
        UCD: this.props.userDetail.traderCode,
        AD: AccDet.D,
        UD: this.props.userDetail.UD,
        STOCK_QTY_FORMAT: selectedCmdty?.STOCK_QTY_FORMAT,
        STOCK_QTY_ROUND: selectedCmdty?.STOCK_QTY_ROUND,
        STOCK_RATE_FORMAT: selectedCmdty?.STOCK_RATE_FORMAT,
        STOCK_RATE_ROUND: selectedCmdty?.STOCK_RATE_ROUND,
        TOTAL_FC_PAMT: this.state.selectedCurrency ?  getFormattedRate(getPureNumber(totalPrem) * this.state.selectedCurrency.R, rateMinMax.maximumFractionDigits, rateMinMax.maximumFractionDigits, true, rateRoundOff) : '',
        CURRENCY: this.state.selectedCurrency?.S || '',
    };

    // Step 11: Submit payload
    this.props.placeRequest(payload);
    };


    onSelectCmdty = (cmdty) => {
        this.setState({
            selectedCmdty: cmdty,
            rows: [], // reset table rows
            newRow: { stock: '', qty: '', qtyOZ: '', premRate: '', premAmt: '' }, // reset input row        
            errorMsg: '' // clear any previous errors
        });
    };

    onSelectLocation = (loc) => {
        const timeOptions = this.generateTimeOptions(loc.workingHourStart, loc.workingHourEnd);
        this.setState({ 
            selectedLocation: loc,
            collectionTime: '', // reset previous selection
            timeOptions: timeOptions,
            startDate: null
         });
    };

    handleRemoveRow = idx => {
        this.setState(s => ({ rows: s.rows.filter((_, i) => i !== idx) }));
    };


    handleRowChange = (index, field, e) => {
        const val = e.target.value;
        this.setState(s => {
            const rows = [...s.rows];
            const updatedRow = { ...rows[index], [field]: val };

            const selectedCmdtyData = this.state.selectedCmdty?.DATA?.find(item => item.STK === updatedRow.stock)?.RATES[0];
            if (selectedCmdtyData) {
                const factor = selectedCmdtyData.CONV_FACT || '';
                const rate = selectedCmdtyData.PREM ?? '';
                const unit = selectedCmdtyData.UNIT || '';
                const qtyNum = parseFloat(updatedRow.qty) || '';
                const qty = factor * qtyNum;

                let premAmt = '';
                let premRate = '';

                if (rate && rate !== 0) {
                    if (unit.toLowerCase() === "pcs") {
                        premAmt = (qtyNum * rate).toFixed(2);
                    } else {
                        const conversionUnit = this.props.unitDetails[unit];
                        premAmt = (qty * rate * conversionUnit).toFixed(2);
                    }
                    premRate = `${rate.toFixed(2)}/${unit}`;
                }

                const qtyMinMax = getMinMaxFractionDigits(this.state.selectedCmdty?.STOCK_QTY_FORMAT || '#,##0.000');
                const rateMinMax = getMinMaxFractionDigits(this.state.selectedCmdty?.STOCK_RATE_FORMAT || '#,##0.000');
                const qtyRoundOff = this.state.selectedCmdty?.STOCK_QTY_ROUND ?? 3;
                const rateRoundOff = this.state.selectedCmdty?.STOCK_RATE_ROUND ?? 2;

                updatedRow.qtyOZ = getFormattedRate(qty, qtyMinMax.minimumFractionDigits, qtyMinMax.maximumFractionDigits, true, qtyRoundOff);
                updatedRow.premRate = `${getFormattedRate(rate, rateMinMax.minimumFractionDigits, rateMinMax.maximumFractionDigits, true, rateRoundOff)}/${unit}`;
                updatedRow.premAmt = getFormattedRate(premAmt, rateMinMax.minimumFractionDigits, rateMinMax.maximumFractionDigits, true, rateRoundOff);
            }

            rows[index] = updatedRow;
            return { rows };
        });
    };


    handleNewRowChange = (field, e) => {
        const val = e.target.value;
        this.setState(s => {
            const nr = { ...s.newRow, [field]: val };

            const selectedCmdtyData = this.state.selectedCmdty?.DATA?.find(item => item.STK === nr.stock)?.RATES[0];
            if (!selectedCmdtyData) {
                return { newRow: nr }; // Just update the field, skip further processing
            }
            const factor = selectedCmdtyData?.CONV_FACT || '';
            const rate = selectedCmdtyData?.PREM ?? ''; // could be 0
            const unit = selectedCmdtyData?.UNIT || '';
            const qtyNum = parseFloat(nr.qty) || '';
            const qty = factor * qtyNum;

            let premAmt = '';
            let premRate = '';

            // Only calculate if rate is > 0
            if (rate && rate !== 0) {
                if (unit.toLowerCase() === "pcs") {
                    premAmt = (qtyNum * rate).toFixed(2);
                } else {
                    const conversionUnit = this.props.unitDetails[unit];
                    premAmt = (qty * rate * conversionUnit).toFixed(2);
                }

                premRate = `${rate.toFixed(2)}/${unit}`;
            }

           const qtyMinMax = getMinMaxFractionDigits(this.state.selectedCmdty?.STOCK_QTY_FORMAT || '#,##0.000');
           const rateMinMax = getMinMaxFractionDigits(this.state.selectedCmdty?.STOCK_RATE_FORMAT || '#,##0.000');
           const qtyRoundOff = this.state.selectedCmdty?.STOCK_QTY_ROUND ?? 3;
           const rateRoundOff = this.state.selectedCmdty?.STOCK_RATE_ROUND ?? 2;
            nr.qtyOZ = getFormattedRate(qty, qtyMinMax.minimumFractionDigits, qtyMinMax.maximumFractionDigits, true, qtyRoundOff);
            nr.premRate = `${getFormattedRate(rate, rateMinMax.minimumFractionDigits, rateMinMax.maximumFractionDigits, true, rateRoundOff)}/${unit}`;
            nr.premAmt = getFormattedRate(premAmt, rateMinMax.minimumFractionDigits, rateMinMax.maximumFractionDigits, true, rateRoundOff);

            return { newRow: nr };
        });
    };

    handleAddRow = () => {
        this.setState(s => ({
            rows: [...s.rows, s.newRow],
            newRow: { stock: '', qty: '', qtyOZ: '', premRate: '', premAmt: '' },
        }));
    };

    generateTimeOptions = (startTime, endTime) => {
    const opts = [];

    // Convert to moment objects
    let current = moment(startTime, 'h:mm A');
    const end = moment(endTime, 'h:mm A');

    // Loop till current is <= end
    while (current <= end) {
        opts.push(current.format('h:mm A'));
        current.add(30, 'minutes');
    }

    return opts;
};

    handleCollectionTimeChange = e => {
        this.setState({ collectionTime: e.target.value });
    }
    afterOpenModal() {
        try {
            const thisComponent = this.refs.placeReq;
            const directionData = [
                { classNames: 'placeRequestModal', elementType: 'normal', applyTo: 'all', tagNames: 'div' },
            ];
            setDirection(thisComponent, directionData, this.props.selectedLang);
        } catch (e) {
            this.props.logFileCreation({ error: e.message, originFunction: 'afterOpenModal', component: "PlaceRequest" });
        }
    }

    isWorkingDay = (date) => {
        const workingDays = this.state.selectedLocation?.locationWorkingDays || [];

        const dayMap = {
            Sun: 0,
            Mon: 1,
            Tue: 2,
            Wed: 3,
            Thu: 4,
            Fri: 5,
            Sat: 6,
        };

        const allowedDays = workingDays.map(day => dayMap[day]);
        const currentDay = date.day(); // 0 = Sun, 1 = Mon, ..., 6 = Sat

        const isWorkDay = allowedDays.includes(currentDay);
        const today = moment().startOf('day');
        const dateMoment = moment(date).startOf('day');

        // Allow yesterday if it's a working day
        const isYesterdayAndWorkingDay =
            dateMoment.isSame(today.clone().subtract(1, 'day'), 'day') && isWorkDay;

        // Allow today and future dates if working days
        const isTodayOrFutureAndWorkingDay =
            !dateMoment.isBefore(today, 'day') && isWorkDay;

        return isYesterdayAndWorkingDay || isTodayOrFutureAndWorkingDay;
    };

    onCurrencyChange = (currency) => {
        this.setState({ selectedCurrency: currency });
    }

    render() {
        const { isOpen, onClose, currencyData, DFA } = this.props;
        const { locationDetails, selectedCmdty, selectedLocation, columns, rows, newRow, collectionTime, timeOptions, premiumDetails, openPositions } = this.state;

        // Map open position for selectedCmdty
        let openPosition = '';
        if (openPositions && selectedCmdty?.DESC) {
            const found = openPositions.find(pos => pos.cmdty === selectedCmdty.DESC);
            openPosition = found ? found.position : '';
        }

        const totalQtyOZFloat = [...rows, newRow]
            .reduce((sum, r) => sum + getPureNumber(r.qtyOZ || 0), 0);

        const totalPremFloat = [...rows, newRow]
            .reduce((sum, r) => sum + getPureNumber(r.premAmt || 0), 0);


        const qtyMinMax = getMinMaxFractionDigits(this.state.selectedCmdty?.STOCK_QTY_FORMAT || '#,##0.000');
        const rateMinMax = getMinMaxFractionDigits(this.state.selectedCmdty?.STOCK_RATE_FORMAT || '#,##0.000');
        const qtyRoundOff = this.state.selectedCmdty?.STOCK_QTY_ROUND ?? 3;
        const rateRoundOff = this.state.selectedCmdty?.STOCK_RATE_ROUND ?? 2;
        const totalQtyOZ = getFormattedRate(totalQtyOZFloat, qtyMinMax.maximumFractionDigits, qtyMinMax.maximumFractionDigits, true, qtyRoundOff);
        const totalPrem = getFormattedRate(totalPremFloat, rateMinMax.maximumFractionDigits, rateMinMax.maximumFractionDigits, true, rateRoundOff);
        const amtInSelectedCurrency = this.state.selectedCurrency ? getFormattedRate(totalPremFloat * this.state.selectedCurrency.R, rateMinMax.maximumFractionDigits, rateMinMax.maximumFractionDigits, true, rateRoundOff) : '';

        // Check if the combined qty(existing + current input) exceeds the current position
        const disableAddRow = (parseToNumber(totalQtyOZFloat)) > parseToNumber(openPosition)

        const disableAddIcon = !newRow.stock || !newRow.qty || disableAddRow;
        const addRowTooltip = !newRow.stock ? "Please select a stock" : !newRow.qty ? "Please enter quantity" : "";

        return (
            <div id="addWidgetMainDiv" className={`${this.props.language}`}>
                <Modal
                    isOpen={isOpen}
                    onRequestClose={onClose}
                    contentLabel="Place Request Modal"
                    closeTimeoutMS={350}
                    onAfterOpen={this.afterOpenModal}
                    className={`${deliveryStyles.delModals} ${deliveryStyles.placeReqModal}`}
                    overlayClassName="overlay"
                    shouldCloseOnOverlayClick={false}
                >
                    <div ref="placeReq" className="placeRequestModal">
                        <div className={`${styles.reporthead} ${deliveryStyles.modalHeader} reportheader`}>
                            <label className="rptHeader">{i18next.t('placeDeliveryReq')}</label>
                            <span onClick={this.handleCloseClick} id="closeViewModal" className={`${styles.closeIcon} closeIcon commonCloseIcon`}><MUIIconWithTooltip icon={"Close"} className={"closeBtn"} title={i18next.t("close")} /></span>
                        </div>

                        <div className={`${deliveryStyles.modalBody} ${deliveryStyles.placeReqModalBody}`}>
                            <div className="row">
                                <div className="col-6">
                                    <label className={deliveryStyles.modalFieldLabel}>{i18next.t('cmdty')}</label>
                                    <span className={deliveryStyles.mandatory}> *</span>
                                    <DropdownButton
                                        title={selectedCmdty?.DESC}
                                        id="bg-nested-dropdown"
                                        className={`${styles.PoskeepingAcc} ${deliveryStyles.placeReqDrpdown} reportsDropdown btnText`}
                                    >
                                        {premiumDetails?.map((item) => (
                                            <MenuItem
                                                key={item.DESC}
                                                onClick={() => this.onSelectCmdty(item)}
                                                id="rptPosAccListMenu"
                                            >
                                                {item.DESC}
                                            </MenuItem>
                                        ))}
                                    </DropdownButton>
                                </div>

                                <div className="col-6">
                                    <label className={deliveryStyles.modalFieldLabel}>{i18next.t('currPosition') + ' ' + this.props.userDetail.CompanyBaseName}</label>
                                    <input
                                        type="text"
                                        className={`form-control ${deliveryStyles.placeReqDrpdown}`}
                                        disabled
                                        value={openPosition}
                                        style={{ textAlign: 'right' }}
                                    />
                                </div>
                            </div>

                            <div className={`${deliveryStyles.modalTableSection} ${deliveryStyles.prTableSection} mt-2`}>
                                <div id="placeReqTable" className={deliveryStyles.viewDelReqTable}>
                                    <table className={`${deliveryStyles.prTable} table table-sm`}>
                                        <thead>
                                            <tr>
                                                {columns.map(col => (
                                                    <th
                                                        key={col.name}
                                                        className={col.name === "premRate" ? deliveryStyles.premRateHeader : ''}
                                                    >
                                                        {col.title}
                                                    </th>
                                                ))}
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {rows.map((row, i) =>
                                                <tr key={i}>
                                                    <td>{row.stock}</td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className={`form-control form-control-sm text-right ${deliveryStyles.placeReqTblInpField}`}
                                                            value={row.qty}
                                                            onChange={(e) => this.handleRowChange(i, 'qty', e)}
                                                        />
                                                    </td>
                                                    <td>{row.qtyOZ}</td>
                                                    <td className={deliveryStyles.premRateHeader}>{row.premRate}</td>
                                                    <td>{row.premAmt}</td>
                                                    <td>
                                                        <img
                                                            src={removeRowIcon}
                                                            alt="Remove row"
                                                            width={16}
                                                            height={16}
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => this.handleRemoveRow(i)}
                                                        />
                                                    </td>
                                                </tr>
                                            )}

                                            <tr className={deliveryStyles.inputRow}>
                                                <td className={deliveryStyles.stkCodeContainer}>
                                                    <DropdownButton
                                                        title={this.state.newRow.stock || i18next.t('selectStk')}
                                                        id="new-row-stock-dropdown"
                                                        className={`${styles.PoskeepingAcc} reportsDropdown btnText ${deliveryStyles.selectStkCodeField}`}
                                                    >
                                                        {Array.isArray(selectedCmdty?.DATA) &&
                                                            selectedCmdty.DATA
                                                                .filter(opt =>
                                                                    !this.state.rows.some(r => r.stock === opt.STK)
                                                                )
                                                                .map(opt => (
                                                                    <MenuItem
                                                                        key={opt.STK}
                                                                        onClick={() => this.handleNewRowChange('stock', { target: { value: opt.STK } })}
                                                                    >
                                                                        {opt.STK}
                                                                    </MenuItem>
                                                                ))
                                                        }
                                                    </DropdownButton>
                                                </td>

                                                <td>
                                                    <input
                                                        className={`form-control form-control-sm text-right ${deliveryStyles.placeReqTblInpField}`}
                                                        type="number"
                                                        value={newRow.qty}
                                                        onChange={e => this.handleNewRowChange('qty', e)}
                                                        min="0"
                                                        step="1"
                                                        onKeyDown={e => {
                                                            if (
                                                                ['e', 'E', '+', '-', '.'].includes(e.key) // disallow decimals and signs
                                                            ) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onInput={e => {
                                                            if (e.target.value !== '' && (!/^\d*$/.test(e.target.value))) {
                                                                e.target.value = e.target.value.replace(/\D/g, ''); // remove non-digits
                                                            }
                                                        }}
                                                    />
                                                </td>

                                                <td>
                                                    <input
                                                        className={`form-control form-control-sm text-right ${deliveryStyles.placeReqTblInpField}`}
                                                        type="text"
                                                        step="any"
                                                        disabled
                                                        value={newRow.qtyOZ}
                                                    />
                                                </td>

                                                <td>
                                                    <input
                                                        className={`form-control form-control-sm ${deliveryStyles.placeReqTblInpField}`}
                                                        type="text"
                                                        disabled
                                                        value={newRow.premRate}
                                                    />
                                                </td>

                                                <td>
                                                    <input
                                                        className={`form-control form-control-sm text-right ${deliveryStyles.placeReqTblInpField}`}
                                                        type="text"
                                                        step="any"
                                                        disabled
                                                        value={newRow.premAmt}
                                                    />
                                                </td>

                                                <td>
                                                    <img
                                                        src={addrowIcon}
                                                        alt="Add row"
                                                        width={16}
                                                        height={16}
                                                        style={{
                                                            cursor: (!this.props.userDetail.enableShortForPD && disableAddIcon) ? 'not-allowed' : 'pointer',
                                                            opacity: disableAddIcon ? 0.5 : 1
                                                        }}
                                                        onClick={(!this.props.userDetail.enableShortForPD && disableAddIcon) ? null : this.handleAddRow}
                                                        title={addRowTooltip}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>

                                        {!this.props.userDetail.enableShortForPD && disableAddRow &&
                                            <div style={{ color:'var(--errorTxtClr)', fontSize:'12px', width:'200%', marginLeft:'10px', marginTop:'1px', marginBottom:'1px' }}>
                                                {"Insufficient Position. Please adjust Pcs value."}
                                            </div>
                                        }

                                        <tfoot>
                                            <tr>
                                                <td><strong>{i18next.t('total')}</strong></td>
                                                <td></td>
                                                <td><strong>{totalQtyOZ}</strong></td>
                                                <td></td>
                                                <td><strong>{totalPrem}</strong></td>
                                                <td></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>

                            <div className={`row ${deliveryStyles.amtPayable}`}>
                                <div className={deliveryStyles.amtPayableRow}>
                                    <label className={deliveryStyles.modalFieldLabel}>{i18next.t('amtPayable')}</label>
                                </div>
                                <div className={deliveryStyles.amtPayableRow}>
                                    <DropdownButton
                                        title={this.state.selectedCurrency?.S}
                                        id="amtPayable-cmdty-dropdown"
                                        className={`${styles.PoskeepingAcc} reportsDropdown btnText ${deliveryStyles.selectAmtPayableField}`}
                                    >
                                        {(DFA?.currency || [])
                                            .map(currCode => (currencyData || []).find(item => item.S === currCode))
                                            .filter(Boolean)  // remove any unmatched entries
                                            .map((item) => (
                                                <MenuItem
                                                    key={item.S}
                                                    onClick={() => this.onCurrencyChange(item)}
                                                    id="rptPosAccListMenu"
                                                >
                                                    {item.S}
                                                </MenuItem>
                                            ))}
                                    </DropdownButton>
                                </div>
                                <div className={deliveryStyles.amtPayableRow}>
                                        {totalPrem &&
                                            <p className={deliveryStyles.payableAmt}>
                                               {amtInSelectedCurrency}
                                            </p>
                                        }
                                </div>
                            </div>

                            <div className="row my-2">
                                <div className="col-6">
                                    <label className={deliveryStyles.modalFieldLabel}>{i18next.t('location')}</label>
                                    <span className={deliveryStyles.mandatory}> *</span>
                                    <DropdownButton
                                        title={selectedLocation?.displayName || i18next.t('selectLocation')}
                                        id="bg-nested-dropdown"
                                        className={`${styles.PoskeepingAcc} ${deliveryStyles.placeReqDrpdown} reportsDropdown btnText`}
                                    >
                                        {locationDetails
                                            .filter(item => item.displayName)
                                            .sort((a, b) => a.displayName.localeCompare(b.displayName))
                                            .map((item) => (

                                                <MenuItem
                                                    key={item.displayName}
                                                    onClick={() => this.onSelectLocation(item)}
                                                    id="rptPosAccListMenu"
                                                >
                                                    {item.displayName}
                                                </MenuItem>
                                            ))}
                                    </DropdownButton>

                                    {selectedLocation?.notes &&
                                        <p className={deliveryStyles.locationFieldNote}>Note: {selectedLocation?.notes}</p>
                                    }
                                </div>

                                <div className="col-6">
                                    <label className={deliveryStyles.modalFieldLabel}>{i18next.t('collectionDateTime')}</label>
                                    <span className={deliveryStyles.mandatory}> *</span>
                                    <div className={deliveryStyles.collectionDateTimeContainer}>
                                        <div className={deliveryStyles.collectionDate}>
                                            <DatePicker
                                                filterDate={this.isWorkingDay}
                                                readOnly
                                                selected={this.state.startDate}
                                                dateFormat="DD-MM-YYYY"
                                                onChange={this.handleChangeDate}
                                                ref="datepickerRef"
                                                id="lmtOrdDatePicker"
                                                className={`collectionDatePickerIcon trdDropdownInput form-control ${deliveryStyles.collDate}`}
                                                placeholderText="Select Date"
                                            />
                                        </div>

                                        <div className={deliveryStyles.collectionTime}>
                                            <img className={deliveryStyles.clockIcon} src={clockIcon} onClick={() => this.handleAddRow} alt="view" width={16} height={16} />

                                            <select
                                                className={`form-control ${deliveryStyles.selectTime}`}
                                                value={collectionTime}
                                                onChange={this.handleCollectionTimeChange}
                                            >
                                                <option value="">Select Time</option>
                                                {timeOptions.map(t => (
                                                    <option key={t} value={t}>{t}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {selectedLocation?.timezone ? <p className={deliveryStyles.collDateTimeNote}>{selectedLocation?.timezone}</p> : null}
                                </div>
                            </div>

                            <div className={`row ${deliveryStyles.locationDetails}`}>
                                {selectedLocation?.address &&
                                    <div className="col-6">
                                        <label className="mb-0">{i18next.t('Address')}</label>
                                        <p>{selectedLocation?.address}</p>
                                    </div>
                                }

                                {Array.isArray(selectedLocation?.contact) && selectedLocation.contact.length > 0 && (
                                    <div className="col-6">
                                        <label className="mb-0">{i18next.t('contactNo')}</label>
                                        <p>
                                            {selectedLocation.contact.map((item, index) => (
                                                <div key={index}>{item}</div>
                                            ))}
                                        </p>
                                    </div>
                                )}

                                <div className={`col-12 ${deliveryStyles.comments}`}>
                                    <label className={deliveryStyles.modalFieldLabel}>{i18next.t("comments")}</label>
                                    <div className={deliveryStyles.comments}>
                                        <textarea type="text" className={`${deliveryStyles.comment_textarea} form-control trdComments`} id="placeReqComment"></textarea>
                                    </div>

                                    {this.state.errorMsg && (
                                        <p style={{ color:'var(--errorTxtClr)'}}>{this.state.errorMsg}</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className={`${deliveryStyles.modalFooter} ${deliveryStyles.placeReqActionBtn}`}>
                            <button className={`${deliveryStyles.submitBtn} savebutton`} onClick={this.handleSubmitClick}>{i18next.t("submit")}</button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}
